//system
export const API_IP = '/ip';
export const API_FP = '/fp';
export const API_TIME = '/time';

//Auth
export const API_AUTH_LOGIN = '/auth/signin';
export const API_AUTH_CLIENT_SIGNIN = '/auth/client-signin';

//Users
export const API_USERS_TOKEN = '/users/token';
export const API_USERS_NEW88_CHECK = '/predictions/many';
export const API_USERS_SHBET_CHECK = '/users/shbet/check';

//Match
export const API_MATCHS = '/matchs';
export const API_MATCHS_DATE = '/matchs/date';
export const API_MATCHS_BY_DATE = '/match/match-date';
export const API_MATCHS_LIST = '/match/list-match';
export const API_MATCHS_RESULT_LIST = '/match/getMatchResultList';

//Prediction
export const API_PREDICTIONS = '/predictions';
export const API_PREDICTIONS_MANY = '/predictions/many';
export const API_PREDICTIONS_GET = '/predictions/get';
export const API_PREDICTIONS_CLAIM_REWARD = '/predictions/claim-reward';

// World Cup APIs
export const API_TEAMS = '/teams';
/** GET — danh sách đội Châu Á (World Cup) */
export const API_TEAMS_ASIA = '/teams/asia';
export const API_PLAYERS = '/players';
export const API_TEAMS_CHAMPIONS = '/worldcup/teams-champions';
export const API_WORLD_CUP_CHAMPION = '/worldcup/champion';
export const API_TOP_SCORER_PREDICTIONS = '/worldcup/top-scorer-predictions';
/** GET thống kê | POST dự đoán — đội Châu Á vào sâu nhất */
export const API_WORLD_CUP_FINAL_ASIA_TEAM = '/worldcup/final-asia-team';
/** GET thống kê đội | POST dự đoán — đội ghi nhiều bàn nhất trong 1 trận */
export const API_MOST_GOALS_IN_MATCH = '/worldcup/most-goals-in-match';
export const API_BEST_PLAYER_PREDICTIONS = '/worldcup/best-player-predictions';
export const API_WORLD_CUP_TOP_SCORER = '/worldcup/top-scorer';
export const API_WORLD_CUP_BEST_PLAYER = '/worldcup/best-player';
export const API_WORLD_CUP_HISTORY_PREDICTIONS_ACCOUNT = '/worldcup/history-predictions-account';

//Settings
export const API_SETTINGS = '/settings';

//Banner
export const API_BANNER = '/banner';
//LUONGSONTV
export const API_MATCH_SCHEDULE = 'match-schedule';

//Files
export const API_FILES = '/file';

//Lottery APIs
export const API_LOTTERY = '/lottery';
export const API_LOTTERY_PREDICT_CREATE = '/lottery-predict/create';
export const API_LOTTERY_PREDICT_RESULT = '/lottery-predict/result';
export const API_LOTTERY_PREDICT_HISTORY = '/lottery-predict/account';
